// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import { Currency, type CurrencyWireFormat, NewCurrency } from '../Currency/Currency';
import Enums from '../Enums';

export class ProjectStatusAgg {
  readonly id: string;
  readonly name: string;
  readonly count: number;
  readonly totalReadyMixQuantity: string;
  readonly readyMixQuantityUnit: Enums.Unit;
  readonly totalAsphaltQuantity: string;
  readonly asphaltQuantityUnit: Enums.Unit;
  readonly totalAggregateQuantity: string;
  readonly aggregateQuantityUnit: Enums.Unit;
  readonly totalRevenue: Currency;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.count = data.count === undefined ? 0 : data.count;
    this.totalReadyMixQuantity =
      data.totalReadyMixQuantity === undefined ? '0' : data.totalReadyMixQuantity;
    this.readyMixQuantityUnit =
      data.readyMixQuantityUnit === undefined ? Enums.Unit.CuYd : data.readyMixQuantityUnit;
    this.totalAsphaltQuantity =
      data.totalAsphaltQuantity === undefined ? '0' : data.totalAsphaltQuantity;
    this.asphaltQuantityUnit =
      data.asphaltQuantityUnit === undefined ? Enums.Unit.Tn : data.asphaltQuantityUnit;
    this.totalAggregateQuantity =
      data.totalAggregateQuantity === undefined ? '0' : data.totalAggregateQuantity;
    this.aggregateQuantityUnit =
      data.aggregateQuantityUnit === undefined ? Enums.Unit.Tn : data.aggregateQuantityUnit;
    this.totalRevenue = NewCurrency(data.totalRevenue);
  }

  static zero(): ProjectStatusAgg {
    const zeroValues: ExcludeMethodsDeep<ProjectStatusAgg> = {
      id: NIL_UUID,
      name: '',
      count: 0,
      totalReadyMixQuantity: '0',
      readyMixQuantityUnit: Enums.Unit.CuYd,
      totalAsphaltQuantity: '0',
      asphaltQuantityUnit: Enums.Unit.Tn,
      totalAggregateQuantity: '0',
      aggregateQuantityUnit: Enums.Unit.Tn,
      totalRevenue: Currency.zero(),
    };
    return new ProjectStatusAgg(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ProjectStatusAggWireFormat = {
  id: string;
  name: string;
  count: number;
  totalReadyMixQuantity: string;
  readyMixQuantityUnit: string;
  totalAsphaltQuantity: string;
  asphaltQuantityUnit: string;
  totalAggregateQuantity: string;
  aggregateQuantityUnit: string;
  totalRevenue: CurrencyWireFormat;
};

type NewProjectStatusAggProps = PartialDeep<ProjectStatusAgg, { recurseIntoArrays: true }>;
export const NewProjectStatusAgg: (props: NewProjectStatusAggProps) => ProjectStatusAgg = (props) =>
  new ProjectStatusAgg(props);

type NewProjectStatusAggFromWireFormatProps = PartialDeep<
  ProjectStatusAggWireFormat,
  { recurseIntoArrays: true }
>;
export const NewProjectStatusAggFromWireFormat: (
  props: NewProjectStatusAggFromWireFormatProps,
) => ProjectStatusAgg = (props) => new ProjectStatusAgg(props);
